import * as React from 'react';
import bindAllOfThis from 'src/utils/BindThisHelper';
import { Layout } from "antd";
import { EnhancedProps } from 'src/pages/student/models/props';
import SVGComponent from 'src/components/common/SVGComponent';

const { Content } = Layout;
const SmokeImagePath = require('src/assets/qci/sprites/starPods/smoke-takeoff.svg');

export interface Leaving1Props extends EnhancedProps {
}

class Leaving1 extends React.Component<Leaving1Props> {
    constructor(props: Leaving1Props) {
        super(props);
        bindAllOfThis(this, Leaving1.prototype);
    }

    onNext() {
        this.props.onNext();
    }

    componentDidMount() {
        document.body.classList.add("take-off");

        setTimeout(() => {
            this.onNext();
        }, 4000);
    }

    componentWillUnmount(): void {
        document.body.classList.remove("take-off");
    }

    render() {
        let planetCode: string = this.props.currentPlanet.name.toLowerCase() as string;

        let terrainClassName = `planet-terrain planet-terrain-${planetCode}`;
        let podClassName = `star-pod star-pod-landing star-pod-${planetCode}-landing`;
        let podClassLanded = `star-pod star-pod-landed star-pod-${planetCode}-landed`;
        this.props.onChangeAudio("");

        return <Content style={{ height: '100vh', overflow: 'hidden' }}>
            <div className="star-pod-animated">
                <div className={podClassName} />
                <div className={podClassLanded} />
                <SVGComponent
                    path={SmokeImagePath}
                    id="smoke"
                />
            </div>
            <div className={terrainClassName} />
        </Content>;
    }
}

export default Leaving1;



// WEBPACK FOOTER //
// ./src/pages/student/scenes/Leaving1.tsx